import React, { useState } from "react";
import "../css/others/Popup.css";
import BuildFormulaPopup from "./BuilFormulaPopup";
import { apiCall } from "../main/ApiCall";
import { ConfirmPopupProps } from '../interFaces/interfaces';
const clientId = localStorage.getItem("clientId");
const BuildFormulaConfirmPopup: React.FC<ConfirmPopupProps> = ({ onConfirm, onClose }) => {
    const [showSecondPopup, setShowSecondPopup] = useState(false);
    const handleYesClick = async () => {
        try {
            if (!clientId) {
                console.error("Client ID not found in encrypted storage");
                return;
            }
            await apiCall("patch", "/api/client-mappings/default-filters", { isDisabled: false, clientId });
            setShowSecondPopup(true);
        } catch (error) {
            console.error("API call failed:", error);
        }
    };
    const handleSecondPopupConfirm = (confirmed: boolean) => {
        setShowSecondPopup(false);
        if (confirmed) {
            onConfirm(true);
        }
    };
    return (
        <>
            <div className="buildformula-overlay">
                <div className="buildformula-content">
                    <div className="buildformula-header">
                        <h3>Update Build Formula</h3>
                        <button className="buildformula-close-button" onClick={onClose}>&times;</button>
                    </div>
                    <div className="buildformula-body">
                        <p>Do you want to update the build formula before creating a new campaign?</p>
                    </div>
                    <div className="buildformula-footer">
                        <button className="buildformula-button" onClick={handleYesClick}>Yes</button>
                        <button className="buildformula-button" onClick={() => onConfirm(false)}>No</button>
                    </div>
                </div>
            </div>
            {showSecondPopup && clientId && (
                <BuildFormulaPopup onConfirm={handleSecondPopupConfirm} onClose={() => setShowSecondPopup(false)} clientId={clientId} />
            )}
        </>
    );
};
export default BuildFormulaConfirmPopup;